import { render, staticRenderFns } from "./BrushSprites.vue?vue&type=template&id=50c7106b&scoped=true&"
import script from "./BrushSprites.vue?vue&type=script&lang=ts&"
export * from "./BrushSprites.vue?vue&type=script&lang=ts&"
import style0 from "./BrushSprites.vue?vue&type=style&index=0&id=50c7106b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7106b",
  null
  
)

export default component.exports